/**
 * Default: Modules > Mindshape Cookie Consent
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import EventHandler from '../../../shared/dom/event-handler';
import Data from '../../../shared/dom/data';

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '../../../shared/utils/scroll';

import CatMap from './categories/maps';
import CatMedia from './categories/media';

const CONSENT_BUTTON          = SelectorEngine.findOne('button[data-cookie-consent="trigger"]');
const PRIVACY_CONSENT_BUTTONS = SelectorEngine.find('.privacy-info .privacy-info__button');

// -------
// Private
// -------

const registerEvents = () => {
	window.addEventListener('cookieConsent', function () {
		initCategories();
		unlockBodyScrolling(CONSENT_BUTTON);
	});

	// initialize cookie toggle
	if(!Data.get(CONSENT_BUTTON, 'initialized')) {
		EventHandler.on(CONSENT_BUTTON, 'click', () => {
			lockBodyScrolling(CONSENT_BUTTON);
		});

		if(PRIVACY_CONSENT_BUTTONS.length) {
			for(let element of PRIVACY_CONSENT_BUTTONS) {
				EventHandler.on(element, 'click', () => {
					EventHandler.trigger(CONSENT_BUTTON, 'click', {});
				});
			}
		}

		Data.set(CONSENT_BUTTON, 'initialized', true);
	}
};

const isFirstAppearance = () => {
	return !window.cookieConsent.consent;
};

// -------
// Public
// -------

const checkCookieConsentStatus = () => {
	return !!window.cookieConsent;
};

const initCategories = () => {
	CatMap.init();
	CatMedia.init();
};

const init = () => {
	if(isFirstAppearance()) {
		lockBodyScrolling(CONSENT_BUTTON);
	}

	if(checkCookieConsentStatus()) {
		registerEvents();
		initCategories();
	}
};

// -------
// Export
// -------

export default {
	init                    : init,
	initCategories          : initCategories,
	checkCookieConsentStatus: checkCookieConsentStatus
};

